<template>
<div id="container_app">
  <div class="locationWrap mypage">
    <div>
      <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
      <strong class="inner locTit aniBox type_bot gogo">
        <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>마이페이지
      </strong>
    </div>
  </div>
  <div class="contents">
    <div class="inner">
      <div class="subTitWrap aniBox type_left gogo">
        <h2>문의처리현황</h2>
        <div class="right">
          <a href="javascript:" class="btn_blue" @click="goQnA()">문의하기</a>
        </div>
      </div>


      <div class="inputArea" v-if = "searchqna">
        <div>
          <b-table striped hover :items="items"></b-table>
        </div>
        <div class="searchqnalist">
          <div class="qnalistinfo_1">고객문의를 통해 이메일 & SMS 문의를 등록하셨나요?</div>
          <div class="qnalistinfo_2">등록하신 문의 건에 대한 내역조회를 하실 수 있습니다.</div>

          <div class = "search_qnatype">
          <input type="radio" class="em" name="eamilsms" id="eamilsms_1" v-model="emailtest" value="remail" autocomplete="off" checked>
          <label class="" for="eamilsms_1">E-Mail</label>

          <input type="radio" class="em" name="eamilsms" id="eamilsms_2" v-model="emailtest" value="rsms" autocomplete="off">
          <label class="" for="eamilsms_2">SMS</label>
          </div>

          <p><input type="text" class="input_ty3"></p>

          <a href="javascript:" class="btn_blue" @click="searchQnA()">조회</a>
        </div>
       </div>

      <div class="qnaWrap" v-if = "qnaWrap">

        <div class="qnalistinfo_1">고객문의를 통해 이메일 & SMS 문의를 등록하셨나요?</div>
        <div class="qnalistinfo_2">등록하신 문의 건에 대한 내역조회를 하실 수 있습니다.</div>
        
        <div class="tblArea aniBox type_bot gogo">
         <table class="qnalist">
           <colgroup>
              <col width="15%">
              <col width="*">
              <col width="15%">
              <col width="10%">
              <col width="20%">
              <col width="15%">
           </colgroup>
           <thead>
             <tr>
              <th>접수번호</th>
              <th>제목</th>
              <th>요청유형</th>
              <th>답변방식</th>
              <th>등록일</th>
              <th>상태</th>
            </tr>
           </thead>
           <tbody>

            <tr v-for="listItem in gridData" v-bind:key="listItem.keyid">
              <td>123456</td>
              <td class="qnalist_title" v-text="listItem.title"></td>
              <td>플랫폼관련</td>
              <td>email</td>
              <td  v-text="dateFmt(listItem.regDate)"></td>
              <td>접수대기</td>
            </tr>
           </tbody>
         </table>
       </div>

        <div class="searchNothing" v-if="gridData.length === 0">
          <img src="/static/images/contents/icon_info.png" alt="">
          <p>조회결과가 없습니다.</p>
        </div>
        
        <paginate
         v-model="pageNo" v-if="pageInfo.finalPageNo"
         :page-count="pageInfo.finalPageNo"
         :page-range="10"
         :click-handler="loadData"
         :prev-text="'〈'"
         :prev-link-class="'first'"
         :next-text="'〉'"
         :next-class="'last'"
         :page-link-class="''"
         :first-last-button="'true'"
         first-button-text="〈〈"
         last-button-text="〉〉"
         :container-class="'paging'">
        </paginate>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'
import VuejsPaginate from 'vuejs-paginate'
import Datepicker from 'vuejs-datepicker'
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'QnAList',
  data () {
    return {
      gridData: [],
      pageInfo: [],
      pageNo: 1,
      countPerPage: 10,
      searchOpt: {
        keyWord: '',
        keyType: '01'
      },
      startDate: moment().add(-1, 'W').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      ko: ko,
      fromDisabledDates: {
        to: moment().add(-1, 'W').toDate()
      },
      toDisabledDates: {
        from: moment().toDate()
      },
      searchqna: true,
      qnaWrap: false
    }
  },
  components: {
    'paginate': VuejsPaginate,
    Datepicker
  },
  methods: {
    stringReplace (contents) {
      return contents.replace(/(?:\r\n|\r|\n)/g,"</br>")
    },
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    searchQnA() {
      this.qnaWrap = true;
      if (this.qnaWrap) {
        this.searchqna = false;
      }
    },
    goQnA() {
      this.$router.push('/support/qna')
    },
    loadData (no) {
      var _this = this
      var pageNo = no || 1
      var params = {
        pageNo: pageNo,
        keyWord: _this.searchOpt.keyWord,
        keyType: _this.searchOpt.keyType,
        startDate: _this.startDate,
        endDate: _this.endDate,
        countPerPage: _this.countPerPage
      }
      axios.get('/web/api/board/my/QNA', {withCredentials: true, params: params})
        .then(response => {
          if (response.data.result) {
            this.gridData = response.data.result
          } else {
            this.gridData = []
          }
          this.pageInfo = response.data.page
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    setSearchOptDate: function (d, o) {
      var _this = this
      _this.startDate = moment().add(d, o).format('YYYY-MM-DD')
      _this.endDate = moment().format('YYYY-MM-DD')
    },
    disableStartState: function (s) {
      var _this = this
      _this.startDate = moment(s).format('YYYY-MM-DD')
      _this.fromDisabledDates.to = s
    },
    disableEndState: function (s) {
      var _this = this
      _this.endDate = moment(s).format('YYYY-MM-DD')
      _this.toDisabledDates.from = s
    }
  },
  created () {
    this.loadData(1)
  },
  updated () {
    this.$nextTick(function () {
      $('.myList dt').unbind('click')

      $('.myList dt').click(function () {
        if ($(this).hasClass('on')) {
          $(this).parent('dl').removeClass('on')
          $(this).removeClass('on')
          $(this).next('dd').slideUp(200)
        } else {
          $(this).parent('dl').addClass('on')
          $(this).addClass('on')
          $(this).next('dd').slideDown(250)
        }
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.paging {
  padding-top : 20px;
}
.vdp-datepicker {
  display: inline-block;
}
.vdp-datepicker__calendar {
  background-color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/QnaList.vue